import React, { Fragment } from "react";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionRejectButton from "./BulkActionRejectButton";
import ApproveAllButton from "./ApproveAllButton";

const BulkConfirmationButton = (props: any) => {
  return (
    <Fragment>
      <BulkActionApproveButton {...props} />
      <BulkActionRejectButton {...props} />
      <ApproveAllButton
        subcontractorPurchaseInvoiceSummaryId={
          props.filterValues.SubcontractorPurchaseInvoiceSummaryId
        }
        subcontractorId={props.filterValues.SubcontractorId}
      />
    </Fragment>
  );
};

export default BulkConfirmationButton;
